import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AddressFailReason} from "../../../dto/address-fail-reason";
import {AddressCustomersService} from "../../../home/services/address-customers.service";
import {AddressUpdateModel} from "../../../models/address-update-model";

@Component({
  selector: 'app-address-confirm-dialog',
  templateUrl: './address-confirm-dialog.component.html',
  styleUrls: ['./address-confirm-dialog.component.css']
})
export class AddressConfirmDialogComponent implements OnInit {

  public title = 'Delete';
  public text = 'Are you sure you want to delete this item?';
  public confirm = 'Confirm';
  public cancel = 'Cancel';
  public showFailReasonDropDown = false;

  failReasons: AddressFailReason[];
  failReason: AddressFailReason;

  constructor(
    private addressCustomersService: AddressCustomersService,
    public dialogRef: MatDialogRef<AddressConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
    if (this.data != null) {
      this.title = this.data.title || this.title;
      this.text = this.data.text || this.text;
      this.cancel = this.data.cancel || this.cancel;
      this.confirm = this.data.confirm || this.confirm;
      this.showFailReasonDropDown = this.data.showFailReasonDropDown ?? this.showFailReasonDropDown;
    }

    this.addressCustomersService.getPossibleAddressFailReasons().subscribe((reasons) => {
        this.failReasons = reasons;
      }
    );
  }

  isYesDisabled(): boolean {
    return this.showFailReasonDropDown && this.failReason == null;
  }

  onYesClick(): void {
    this.dialogRef.close(new AddressUpdateModel(true, this.failReason?.code));
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
